import React from "react";

const ContractIcon = ({ cls }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={cls}
    >
      <g clipPath="url(#clip0_3322_38532)">
        <path
          d="M10 23C10 23.553 9.553 24 9 24H5C2.243 24 0 21.757 0 19V5C0 2.243 2.243 0 5 0H11C13.757 0 16 2.243 16 5V9C16 9.553 15.553 10 15 10C14.447 10 14 9.553 14 9V5C14 3.346 12.654 2 11 2H5C3.346 2 2 3.346 2 5V19C2 20.654 3.346 22 5 22H9C9.553 22 10 22.447 10 23ZM6 13H5C4.447 13 4 13.447 4 14C4 14.553 4.447 15 5 15H6C6.553 15 7 14.553 7 14C7 13.447 6.553 13 6 13ZM11 13H10C9.447 13 9 13.447 9 14C9 14.553 9.447 15 10 15H11C11.553 15 12 14.553 12 14C12 13.447 11.553 13 11 13ZM6 17H5C4.447 17 4 17.447 4 18C4 18.553 4.447 19 5 19H6C6.553 19 7 18.553 7 18C7 17.447 6.553 17 6 17ZM6 5H5C4.447 5 4 5.447 4 6C4 6.553 4.447 7 5 7H6C6.553 7 7 6.553 7 6C7 5.447 6.553 5 6 5ZM11 5H10C9.447 5 9 5.447 9 6C9 6.553 9.447 7 10 7H11C11.553 7 12 6.553 12 6C12 5.447 11.553 5 11 5ZM6 9H5C4.447 9 4 9.447 4 10C4 10.553 4.447 11 5 11H6C6.553 11 7 10.553 7 10C7 9.447 6.553 9 6 9ZM11 9H10C9.447 9 9 9.447 9 10C9 10.553 9.447 11 10 11H11C11.553 11 12 10.553 12 10C12 9.447 11.553 9 11 9ZM24 17.5V20.5C24 22.43 22.43 24 20.5 24H15.5C13.57 24 12 22.43 12 20.5V17.5C12 15.742 13.308 14.296 15 14.051V14C15 12.897 15.897 12 17 12H19C20.103 12 21 12.897 21 14V14.051C22.692 14.296 24 15.742 24 17.5ZM14 17.5V18H22V17.5C22 16.673 21.327 16 20.5 16H15.5C14.673 16 14 16.673 14 17.5ZM22 20.5V20H19C19 20.553 18.553 21 18 21C17.447 21 17 20.553 17 20H14V20.5C14 21.327 14.673 22 15.5 22H20.5C21.327 22 22 21.327 22 20.5Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_3322_38532">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ContractIcon;
